module.exports = __webpack_public_path__ + "img/cp1-logo.d0461bc9.svg";